import axios from "axios";
import { handleAPIError, handleAPISuccess } from "./utils/utilsAPI";
import { createStatusValidation, getStatusByOwnerIdValidation, tokenAndIdValidation, typeAndIdValidation } from "./utils/validateAPI";
import { BASE_URL } from "./constant";
import store from "../store";
import { successToast } from "../store/dbFilter/actions";

const token = "8lQzN922rpRDaMbh3m5J";

const apiStatus = axios.create({
  baseURL: `${BASE_URL}/statusLogs`,
});

/**
 * validates the argument received and Makes an API call to create or update the status
 * @param {object} statusDetail - contains all the data required to create a status
 * @returns {Promise} - Resolves when the promise returns status details  or logs in case of failure.
 */
const createStatus = async (statusDetail) => {
  const payload = { token: token, ...statusDetail };
  try {
    await createStatusValidation.validate(payload);
    const res = await apiStatus.post(`/`, payload);
    return handleAPISuccess(res);
  } catch (err) {
    console.log("API call failed: ", err);
    handleAPIError(err); // Call error handler
    throw err;
  }
};

/**
 * validates the argument received and Makes an API call to get the status
 * @param {string} id - id of the status to get the particular status details or "all" to get all the status
 * @param {string} type - type of the status to get the particular status details or "*" to get all the status
 * @returns {Promise} - Resolves when the promise returns all the status or empty array in case of no status or logs in case of failure.
 */
const getStatus = async (id = "all", type = "*") => {
  const payload = { token: token, type: type, id: id };
  try {
    await typeAndIdValidation.validate(payload);
    const res = await apiStatus.get(`/`, { params: payload });
    return handleAPISuccess(res);
  } catch (err) {
    console.log("API call failed: ", err);
    handleAPIError(err); // Call error handler
    throw err;
  }
};

/**
 * validates the argument received and Makes an API call to get the recent logs
 * @param {string} id - id of the status to fetch the recent logs
 * @returns {Promise} - Resolves when the promise returns  status or logs in case of failure.
 */
const getRecentStatus = async (id) => {
  const payload = { token: token, id: id };
  try {
    await tokenAndIdValidation.validate(payload);
    const res = await apiStatus.get(`/recent`, { params: payload });
    return handleAPISuccess(res);
  } catch (err) {
    console.log("API call failed: ", err);
    handleAPIError(err); // Call error handler
    throw err;
  }
};

/**
 * validates the argument received and Makes an API call to get the status by owner Id.
 * @param {string} ownerId - id of the owner to fetch all the status under them.
 * @returns {Promise} - Resolves when the promise returns all the status or logs in case of failure.
 */
const getStatusByOwnerId = async (data) => {
  const payload = { token: token, ...data };
  try {
    await getStatusByOwnerIdValidation.validate(payload);
    const res = await apiStatus.get(`/byOwnerId`, { params: payload });
    const { data } = handleAPISuccess(res);
    const { allStatus } = data;
    if (allStatus?.length === 0) {
      console.log("No status details");
      store.dispatch(successToast({ title: "Success", message: "No Status details available" }));
    }
    return allStatus;
  } catch (err) {
    console.log("API call failed: ", err);
    handleAPIError(err); // Call error handler
    throw err;
  }
};

export { createStatus, getStatus, getRecentStatus, getStatusByOwnerId };
